var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecruitRegiments6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 58,
    viewBox: "0 0 132 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 3C117.359 3 129 14.6407 129 29C129 43.3594 117.359 55 103 55C88.6406 55 77 43.3594 77 29C77 14.6407 88.6406 3 103 3Z",
    stroke: "#1A1A18",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85832 33.445L1.18628 31.525C3.79415 28.2209 6.23434 24.8129 8.49821 21.293C10.7622 17.7811 12.9621 14.0371 15.1063 10.0694L18.7543 10.637L17.7861 30.133L24.5619 29.653L23.5063 32.3009L17.5063 32.3968L17.0743 41.125L13.4743 43.285C13.9222 39.9489 14.1463 36.373 14.1463 32.581H11.9863C9.28206 32.581 5.89832 32.869 1.85832 33.445ZM15.0103 14.101L4.39445 30.133H14.1463L15.0103 14.101Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5465 20.6792C96.5465 19.1115 96.4183 17.5914 96.1624 16.1192C95.8983 14.6554 95.4025 13.3915 94.6745 12.3272C93.9382 11.2712 92.9143 10.7433 91.6025 10.7433C90.2105 10.7433 89.0743 11.3192 88.1785 12.4632C87.2904 13.6074 86.6584 15.0235 86.2744 16.7274C85.8904 18.4233 85.6984 20.1592 85.6984 21.9352C85.7305 23.9116 86.0583 25.5352 86.6823 26.8153C87.3063 28.0872 88.4666 28.8633 90.1624 29.1272C90.5544 29.1272 91.0824 29.1911 91.7464 29.3271C92.4664 29.1911 92.9464 29.1272 93.1864 29.1272V30.1353C93.2503 30.1353 92.8905 30.2313 92.1063 30.4391C91.3144 30.6394 90.4906 30.7593 89.6344 30.7993C89.4984 30.7354 89.2822 30.7113 88.9705 30.7113C87.4106 30.5514 86.1146 30.0471 85.0666 29.1994C84.0184 28.3434 83.2426 27.2631 82.7305 25.9592C82.2183 24.6474 81.9465 23.2074 81.9064 21.6393C81.9064 19.5673 82.3143 17.5671 83.1303 15.6393C83.9463 13.7113 85.1304 12.1515 86.6664 10.9515C88.2103 9.75938 90.0022 9.15928 92.0425 9.15928C93.9545 9.24728 95.4826 9.79155 96.6183 10.8076C97.7623 11.8156 98.5625 13.1352 99.0262 14.7752C99.4825 16.4072 99.7144 18.3114 99.7144 20.4872C99.5943 25.1674 98.6584 29.0233 96.8983 32.0553C95.1381 35.0871 93.1143 37.3353 90.8424 38.8074C88.5706 40.2711 86.5144 41.2632 84.6746 41.7671C82.8343 42.2712 81.6423 42.5192 81.0985 42.5192L80.8984 41.1272C81.4023 41.1272 82.4503 40.8951 84.0343 40.4311C85.6105 39.9752 87.3706 39.0633 89.2984 37.7034C91.2343 36.3431 92.9223 34.2633 94.3702 31.4634C95.8186 28.6551 96.5465 25.0635 96.5465 20.6792Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1211 15L46.6815 18.5786L53.2424 22.1569L46.6814 26.2358L40.1814 29.7358L33.5605 25.7358L27 22L33.5605 18.5786L40.1211 15Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5404 36.6996L27.3606 29.468L27.1814 22.2358L33.6814 25.7358L40.1812 29.7358V36.7358V44.2358L33.8609 40.4677L27.5404 36.6996Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1814 29.7358L46.8609 26.0039L53.1814 22.2358L53.0018 29.4681L52.8224 36.7001L46.5019 40.4677L40.1814 44.2358V37.2358V29.7358Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0607 30.0607C82.6464 29.4749 82.6464 28.5251 82.0607 27.9393L72.5147 18.3934C71.9289 17.8076 70.9792 17.8076 70.3934 18.3934C69.8076 18.9792 69.8076 19.9289 70.3934 20.5147L78.8787 29L70.3934 37.4853C69.8076 38.0711 69.8076 39.0208 70.3934 39.6066C70.9792 40.1924 71.9289 40.1924 72.5147 39.6066L82.0607 30.0607ZM56 30.5H81V27.5H56V30.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.121 14L122.681 17.5786L129.242 21.1569L122.681 25.2358L116.181 28.7358L109.561 24.7358L103 21L109.561 17.5786L116.121 14Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54 35.6996L103.361 28.468L103.181 21.2358L109.681 24.7358L116.181 28.7358V35.7358V43.2358L109.861 39.4677L103.54 35.6996Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.181 28.7358L122.861 25.0039L129.181 21.2358L129.002 28.4681L128.822 35.7001L122.502 39.4677L116.181 43.2358V36.2358V28.7358Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-895 -330)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitRegiments6);
export default __webpack_public_path__ + "static/media/recruit_regiments6.8ff00ca59668f1f075982f76a15d08d8.svg";
export { ForwardRef as ReactComponent };